
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.48.75a2.598 2.598 0 012.597 2.596v17.308a2.598 2.598 0 01-2.596 2.596H7.096A2.598 2.598 0 014.5 20.654V3.346A2.598 2.598 0 017.096.75h10.385zm-3.46 1.73a1.731 1.731 0 01-3.462 0H7.096a.865.865 0 00-.865.866v17.308a.865.865 0 00.865.865h10.385a.865.865 0 00.865-.865V3.346a.865.865 0 00-.865-.865h-3.462z"}})])
          )
        }
      }
    